import * as z from "zod";

export const activateExistingContextualMerchant = {
  name: "activateExistingContextualMerchant" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
